import { render, staticRenderFns } from "./ApplicationOfAIForMarketing.vue?vue&type=template&id=187e978f&"
import script from "./ApplicationOfAIForMarketing.vue?vue&type=script&lang=js&"
export * from "./ApplicationOfAIForMarketing.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationOfAIForMarketing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports